import { FC } from 'react';

import BottlePriceListing from 'components/main/BottlePrice';

const BottlePrice: FC = () => <BottlePriceListing />;

export default BottlePrice;
